import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { UserContextProvider } from './context/UserContext';
import { ToastProvider } from './components/Toast';
import { router } from './router';
import { queryClient } from './lib/query-client';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <UserContextProvider>
          <RouterProvider router={router} />
        </UserContextProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
